import styled from 'styled-components';

export const ListDrop: any = styled.div`
display: flex;
height: 51px;
align-items: center;
padding-left: 16px;
width: 220px;
font-family: Roboto;
padding-right: 10px;
cursor: pointer;
background-color: white;
  :hover {
    background-color: #E1E1E1;
  }
`;
